
export default {
  computed: {
    buttonPrimaryColor () {
      return '#FFC145'
    }
  }
}
